import { Component } from '@angular/core';
import { DisplayServiceProvider } from '../../../core/services/display-service/display-service';
import { ENVIRONMENT } from '../../../../../environments/environment';
import { IonicPage } from 'ionic-angular';
import { ListConfig } from '../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/list-config.interface';
import { StorageServiceProvider } from '../../../core/services/storage-service/storage-service';
import { TextServiceProvider } from '../../../core/services/text-service/text-service';
import { UserTaskAssignedListPage } from './user-task-assigned-list/user-task-assigned-list';
import { UserTaskClosedListPage } from './user-task-closed-list/user-task-closed-list';
import { UserTaskNewListPage } from './user-task-new-list/user-task-new-list';

@IonicPage()
@Component({
  selector: 'page-user-task-list',
  templateUrl: 'user-task-list.html',
})
export class UserTaskListPage {
  public configNew: ListConfig;
  public configAssigned: ListConfig;
  public configClosed: ListConfig;
  public db: any;
  public engineUrl = ENVIRONMENT.engineUrl;
  public newLoading: boolean = true;
  public assignedLoading: boolean = true;
  public closedLoading: boolean = true;
  public newTasksPage = UserTaskNewListPage;
  public assignedTasksPage = UserTaskAssignedListPage;
  public closedTasksPage = UserTaskClosedListPage;

  constructor(
    private displayService: DisplayServiceProvider,
    private storageService: StorageServiceProvider,
    public textService: TextServiceProvider,
  ) {}

  ngOnInit() {
    this.db = this.storageService.db;
    this.configNew = this.displayService.getScreenComponent('user_tasks_new', 'user_tasks_new');
    this.configAssigned = this.displayService.getScreenComponent('user_tasks_assigned', 'user_tasks_assigned');
    this.configClosed = this.displayService.getScreenComponent('user_tasks_closed', 'user_tasks_closed');
  }
}



// WEBPACK FOOTER //
// ./src/modules/user-tasks/pages/user-task-list/user-task-list.ts